var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvyAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10565",
    "data-name": "Group 10565",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.5,
    height: 21.726,
    viewBox: "0 0 21.5 21.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3059",
    "data-name": "Rectangle 3059",
    width: 21.5,
    height: 21.726,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10564",
    "data-name": "Group 10564",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28905",
    "data-name": "Path 28905",
    d: "M25.242,28.577l-.012-.025-1.414-2.97A1.008,1.008,0,0,0,22.9,25h0a1.008,1.008,0,0,0-.919.581L20.56,28.552l-.012.025-.968,2A.792.792,0,1,0,21,31.265l.76-1.566h2.261l.759,1.566a.792.792,0,0,0,1.426-.691Zm-2.72-.462.372-.782.373.782Z",
    transform: "translate(-13.616 -17.453)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28906",
    "data-name": "Path 28906",
    d: "M45.792,24a.792.792,0,0,0-.792.792v5.432a.792.792,0,1,0,1.584,0V24.792A.792.792,0,0,0,45.792,24",
    transform: "translate(-31.421 -16.758)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28907",
    "data-name": "Path 28907",
    d: "M20.708,12.9H19.689V8.826h1.018a.792.792,0,0,0,0-1.584H19.689V7.129a5.324,5.324,0,0,0-5.318-5.318h-.113V.792a.792.792,0,1,0-1.584,0V1.811H8.6V.792a.792.792,0,0,0-1.584,0V1.816A5.322,5.322,0,0,0,1.811,7.129v.113H.792a.792.792,0,1,0,0,1.584H1.811V12.9H.792a.792.792,0,0,0,0,1.584H1.811V14.6A5.322,5.322,0,0,0,7.016,19.91v1.024a.792.792,0,1,0,1.584,0V19.916h4.074v1.018a.792.792,0,1,0,1.584,0V19.916h.113A5.324,5.324,0,0,0,19.689,14.6v-.113h1.018a.792.792,0,0,0,0-1.584m-2.6,1.7a3.739,3.739,0,0,1-3.734,3.734H7.129A3.738,3.738,0,0,1,3.395,14.6V7.129A3.738,3.738,0,0,1,7.129,3.395h7.242a3.738,3.738,0,0,1,3.734,3.734Z",
    fill: "#2e728c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvyAiIcon);
export default __webpack_public_path__ + "static/media/Ivy-Ai-icon.2ffc194bceb869fa321ebba807213223.svg";
export { ForwardRef as ReactComponent };